import { AchievementUnlockModal } from '@/components/AchievementUnlockModal';
import { useAchievementWatcher } from '@/hooks/useAchievementWatcher';

/**
 * Глобальный провайдер ачивок.
 * Рендерится в App.tsx один раз.
 * Слушает БД и показывает модалку при разблокировке.
 */
export function AchievementProvider() {
  const { pendingAchievement, dismissAchievement } = useAchievementWatcher();
  
  return (
    <AchievementUnlockModal
      open={!!pendingAchievement}
      achievement={pendingAchievement}
      onClose={dismissAchievement}
    />
  );
}
